import { createSelector } from 'reselect';
import { KEY, CountriesState } from './types';
import { GlobalState } from 'store/types';

const getCountriesState = (state: GlobalState) => state[KEY] as CountriesState;

const selectLoading = createSelector(
  getCountriesState,
  countries => countries.loading
);

const selectError = createSelector(
  getCountriesState,
  countries => countries.error
);

const selectCountries = createSelector(
  getCountriesState,
  countries => countries.countries
);

export const selectors = {
  selectCountries,
  selectError,
  selectLoading
};
